import { Autocomplete, Popper, TextField, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({
  options,
  searchValue,
  handleChange,
  handleSearch,
}) => {
  return (
    <Box>
      <Autocomplete
        freeSolo
        disablePortal
        options={options}
        getOptionLabel={(option) => (option ? option.name : "")}
        value={searchValue}
        onChange={handleChange}
        onInputChange={(event, newValue) => handleSearch(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search Company..."
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {params.InputProps.endAdornment}
                  <SearchIcon />
                </>
              ),
            }}
          />
        )}
        PopperComponent={(props) => (
          <Popper
            {...props}
            style={{ 
                backgroundColor: "rgba(0, 0, 0, 0.8)",
            }}
          />
        )}
      />
    </Box>
  );
};

export default SearchBar;
